import { styled, Paper, colors } from "@material-ui/core"

export const StyledPaper = styled(Paper)({
  border: `1px solid ${colors.grey[400]}`,
})

export default StyledPaper
